import React from 'react';
import {makeStyles} from '@material-ui/core';
import {ToggleButton, ToggleButtonGroup} from '@material-ui/lab';
import {
  BarChart as BarChartIcon,
  ShowChart as ShowChartIcon,
} from '@material-ui/icons';

const useStyles = makeStyles({
  group: {
    marginLeft: 'auto',
  },
  // Inherit the header's text color, which is chosen for contrast against
  // the meter-type background (see palette.meterTypeTextColor).
  button: {
    color: 'inherit',
    borderColor: 'currentColor',
    '&.Mui-selected': {
      color: 'inherit',
      backgroundColor: 'rgba(255, 255, 255, 0.25)',
    },
    '&.Mui-selected:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.35)',
    },
  },
});

// Bar/line switch shown in the usage chart header. Clicks are kept from
// bubbling so they don't trigger the surrounding AccordionSummary.
export const ChartViewToggle = ({view, onChange}) => {
  const classes = useStyles();
  const stop = (e) => e.stopPropagation();

  return (
    <ToggleButtonGroup
      className={classes.group}
      size="small"
      exclusive
      value={view}
      onClick={stop}
      onChange={(e, next) => {
        e.stopPropagation();
        if (next) onChange(next);
      }}
      aria-label="chart view"
    >
      <ToggleButton
        className={classes.button}
        value="bar"
        aria-label="bar chart view"
      >
        <BarChartIcon />
      </ToggleButton>
      <ToggleButton
        className={classes.button}
        value="line"
        aria-label="line chart view"
      >
        <ShowChartIcon />
      </ToggleButton>
    </ToggleButtonGroup>
  );
};
